import React from "react";
import "../styles/tableStyle.css";
import ReactCardFlip from "react-card-flip";
import {capFirstLetter, shortName} from "./StringUtils";
import PlaidRevalidateButton from "../integrations/PlaidRevalidateButton";
import DeleteConfirmModal from "./DeleteConfirmModal";

class BankGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isFlipped: false,
            basicAccounts: props.basicAccounts,
            plaidItemId: props.plaidItemId,
            accIdToRank: this.initAccIdToRankMap(props.basicAccounts),
            accIdToEnabled: this.initAccIdToEnabledMap(props.basicAccounts),
            institutionName: props.basicAccounts.length >=1 ? props.basicAccounts[0].institutionName : "N/A",
            accountState: props.basicAccounts.length >=1 ? props.basicAccounts[0].accountState : "N/A",
            publicToken: props.basicAccounts.length >=1 ? props.basicAccounts[0].publicToken : "N/A",
            csrfToken: props.csrfToken,
            error: false,
            revalidate: props.basicAccounts.length >=1 ? props.basicAccounts[0].accountState === "OKAY" ? false : true : false,
            stateChanged: false,
            deleteInProgress: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmitEvent = this.handleSubmitEvent.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
    }


    handleToggle(e) {
        this.setState( (prevState) => ({isFlipped: !prevState.isFlipped}));
        e.preventDefault();
    }

    handleInputChange(event) {
        const accId = event.target.getAttribute("data-accid");
        console.log("input value: ", event.target.value);
        /*
         * TODO: Fix Slider! For some reason, if "accIdToEnabled starts with `true` ", then I cannot
         *  get the slider to be in the 'turned on' position.
         */
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const field = event.target.name;
        if (field === 'inputAccountRank') {
            const temp = this.state.accIdToRank;
            temp[accId] = value;
            this.setState({accIdToRank: temp});
            let updatedAccs = this.state.basicAccounts.map((instance) => {
                console.log("instance is: "+JSON.stringify(instance));
                if (instance.plaidAccountId === accId) {
                    instance.accountRank = value;
                    console.log("instance is now: "+JSON.stringify(instance));
                }
                return instance;
            });
            this.setState({basicAccounts: updatedAccs});
        } else if (field === 'inputUserEnabled') {
            const temp = this.state.accIdToEnabled;
            temp[accId] = value;
            this.setState({accIdToEnabled: temp});
            let updatedAccs = this.state.basicAccounts.map((instance) => {
                if (instance.plaidAccountId === accId) {
                    instance.userEnabled = value;
                }
                return instance;
            });
            this.setState({basicAccounts: updatedAccs});
        } else {
            console.log('unrecognized field: ', field);
        }
        this.setState({stateChanged: true})
    }

    async handleSubmitEvent(event) {
        console.log("handle submit event fired.");
        console.log("sending body: ", JSON.stringify(this.state.basicAccounts, null, 2));
        let url = '/api/submit_accounts_config';

        await fetch(url,
            {
                    method: 'POST',
                    credentials: 'include',
                    body: JSON.stringify(this.state.basicAccounts),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': this.state.csrfToken
                    }
            })
            .then(response => response.json())
            .then(response => {
                console.log("response: ", response);
                this.setState({
                    basicAccounts: response,
                    error: false,
                    stateChanged: false
                });
            }).catch(function (err) {
                console.log("error: ", err);
                this.setState({
                    error: true
            });
        });

        event.preventDefault();
    }

    initAccIdToRankMap(accs) {
        let res = {};
        for (let i in accs) {
            let acc = accs[i];
            res[acc.plaidAccountId] = acc.accountRank;
        }
        return res;
    }

    initAccIdToEnabledMap(accs) {
        let res = {};
        for (let i in accs) {
            let acc = accs[i];
            res[acc.plaidAccountId] = acc.userEnabled;
        }
        return res;
    }

    deleteFinished = () => {
        console.log("delete finished");
        this.setState({
            deleteInProgress: false,
            basicAccounts:[]
        })
    }

    deleteCancelled = () => {
        console.log("cancelled.");
        this.setState({
            deleteInProgress: false
        })
    }

    deleteError = () => {
        alert("There was an error deleting the accounts!");
        this.setState({
            deleteInProgress: false
        })
    }

    render() {

        const deleteModal = this.state.deleteInProgress ?
            <DeleteConfirmModal
                plaidItemId={this.state.plaidItemId}
                csrfToken={this.state.csrfToken}
                doneHandler={this.deleteFinished}
                deleteError={this.deleteError}
                cancelHandler={this.deleteCancelled}/> :
            <></>;

        if (this.state.basicAccounts.length < 1)
            return <> </>;

        const revalidateButton =
            (<PlaidRevalidateButton publicToken={this.state.publicToken} csrfToken={this.state.csrfToken} plaidItemId={this.state.plaidItemId} activate={this.state.revalidate}/>);

        const saveButtonClass = this.state.stateChanged ? "ui button card-bottom fluid" : "ui disabled button card-bottom fluid";
        const saveButtonDiv = (
            <div className={saveButtonClass} onClick={(event) => this.handleSubmitEvent(event)}>
                <i className={"save icon"}></i> Save
            </div>
        );

        const bottomButton = ( this.state.revalidate ? revalidateButton : saveButtonDiv );
        const color = this.state.accountState === "OKAY" ? "ui fluid faq teal label" : "ui fluid faq red label";

        const renderDiv = this.state.error ?
            (<div> there was an error </div>) :
            (<form>
                <div className={"ui centered raised fluid card outer"}>
                    <div className={"content"}>
                        <div className={color} onClick={this.handleToggle}>
                            <i className={"sync square icon"}> </i>
                            {this.state.institutionName}
                            <i className={"trash alternate icon"} style={{"float": "right"}} onClick={() => {
                                this.setState({deleteInProgress: true});
                            }}></i>
                        </div>
                        <ReactCardFlip isFlipped={this.state.isFlipped} flipDirection={"horizontal"}>
                            <>
                                {/* -- start of basic table --*/}
                                <div className="ui raised fluid card">
                                    {this.state.basicAccounts.map(account =>
                                        <div className="content" key={account.plaidAccountId}>
                                            <div className="description">{account.officialName}</div>
                                            <br/>
                                            <span className="right floated">
                                                    <label className="ui tag label"> {capFirstLetter(this.state.accIdToRank[account.plaidAccountId])} </label>
                                                </span>
                                            <span>
                                                    <h3>${account.currentBalance}</h3>
                                                </span>
                                        </div>
                                    )}
                                </div>
                                {/* -- end of basic table --*/}
                            </>
                            <>
                                {/* -- start of the advanced table --*/}
                                <div className={"ui raised fluid card"} style={{overflow: 'auto', "maxWidth": "100%"}}>
                                    <table className="ui compact celled unstackable definition table">
                                        <thead>
                                        <tr>
                                            <th>Enabled</th>
                                            <th>Institution</th>
                                            <th>Available </th>
                                            <th>Current </th>
                                            <th>Type</th>
                                            <th>Rank</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.basicAccounts.map((account,i) =>


                                            <tr key={i}>
                                                <td className="collapsing">
                                                    <div className={"ui slider checkbox"}>
                                                        <input name="inputUserEnabled" type="checkbox"
                                                               checked={this.state.accIdToEnabled[account.plaidAccountId] ? "checked" : ""}
                                                               data-accid={account.plaidAccountId}
                                                               onChange={e => this.handleInputChange(e)}/>
                                                        <label></label>
                                                    </div>
                                                </td>
                                                <td> {shortName(account.officialName)}</td>
                                                <td>$ {account.availableBalance}</td>
                                                <td>$ {account.currentBalance}</td>
                                                <td> {capFirstLetter(account.institutionType)}</td>
                                                <td>
                                                    <select className="ui search dropdown" name="inputAccountRank"
                                                            data-accid={account.plaidAccountId}
                                                            onChange={e => this.handleInputChange(e)}
                                                            value={this.state.accIdToRank[account.plaidAccountId]}>
                                                        <option value="First">First</option>
                                                        <option value="Second">Second</option>
                                                        <option value="Third">Third</option>
                                                    </select>

                                                </td>
                                            </tr>

                                        )}
                                        </tbody>
                                    </table>
                                </div>
                                {/*-- end of advanced table --*/}
                            </>
                        </ReactCardFlip>
                        {bottomButton}
                    </div>
                </div>
            </form>);

        return (
            <>
                {deleteModal}
                {renderDiv}
            </>
        );
    }
}

export default BankGroup;